import CONSTANTS from '@/constants'

interface FilterMap {
  [key: string]: string
}

interface Facets {
  [key: string]: Array<string>
}

interface SearchState {
  searchQuery: string
  contexts: Array<string>
  features: Array<string>
  filterMap: FilterMap
  facets: Facets
  algoliaKeys: {
    [key: string]: string | undefined
  }
}

const state: SearchState = {
  searchQuery: '',
  contexts: CONSTANTS.SEARCH.CONTEXTS,
  features: CONSTANTS.SEARCH.FEATURES,
  filterMap: CONSTANTS.SEARCH.FILTER_MAP,
  facets: CONSTANTS.SEARCH.AVAILABLE_FACETS,
  algoliaKeys: CONSTANTS.SEARCH.ALGOLIA_KEYS,
}

export { SearchState, state }
